<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "JALA Trade Users",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_investor_users.plural')) }},
    resourceRoute: {default: 'jala_investor_users'},
    modelVariable: {default: 'jala_investor_user'},
    denyCreate: { type: Boolean, default() { return !this.$auth.hasJalaTradeRole(['admin'])} }
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_investor_users.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_investor_users.plural')),
          href: "/jala_investor_users",
          active: true,
        },
      ],
      filterColumns: {
        'user.name': { type: String, label: this.lodash.upperFirst(this.$t('jala_users.name')) },
        'user.email': { type: String, label: this.lodash.upperFirst(this.$t('jala_users.email')) },
        'user.phone': { type: String, label: this.lodash.upperFirst(this.$t('jala_users.phone')) },
      },
      sortBy: 'user.name',
      sortDesc: false
    }
  },
  computed: {
    columns() {
      return {
        jala_investor_user: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'user.avatar_url',
            label: '#',
            class: 'text-center',
            style: { width: '1%' },
            component: {
              props: ['item'],
              template: `
                <div>
                  <img
                    class="rounded-circle header-profile-user"
                    :src="jalaStorageLink(item.user['avatar'])"
                    alt="Avatar"
                  />
                </div>
              `
            } },
          {
            key: 'user.name',
            label: this.lodash.startCase(this.$t('jala_users.name')),
            sortable: true,
            style: { minWidth: '180px' },
            component: {
              props: ['item'],
              template: `
                <div class="text-truncate" style="max-width: 180px">
                  <router-link :to="'' + item.id" append><h6
                    class="mb-0"
                  >{{ item.user['name'] }}</h6></router-link>
                  <small class="text-muted">{{ item.user['email'] }}</small>
                </div>
              `
            } },
          {
            key: 'state.jala_trade_role',
            label: this.lodash.startCase(this.$t('jala_investor_users.role')),
            style: { minWidth: '110px', width: '110px' },
            formatter: (value) => (
                this.lodash.upperFirst(this.$t(`jala_investor_users.${value || 'admin'}`))
            )
          },
          {
            key: 'user.phone',
            label: this.lodash.startCase(this.$t('jala_users.phone')),
            style: { width: '150px' },
            component: {
              props: ['item'],
              template: `
                <a class="text-body" target="_blank" :href="item.user['phone'] ? 'https://wa.me/' + item.user['phone'].replace('+', '') : '#'">{{ item.user['phone'] }}</a>
              `
            }
          },
          {
            key: 'created_at',
            label: this.lodash.startCase(this.$t('models.created_at')),
            sortable: true,
            style: { minWidth: '110px', width: '110px' },
            formatter: (value) => (
                this.$moment(value).format('DD MMM, YYYY')
            )
          },
          { key: 'action', label: this.$t('Action'), class: 'text-center', style: { minWidth: '110px', width: '110px' } }
        ].map((field) => ({...field, tdClass: 'align-middle'})),
      };
    },
  },
  methods: {
    getModelName(value) {
      return value.user.email || this.getModelKey(value);
    },
    delete(value) {
      return this.$axios.delete(`/jala/investor_users/${value.id}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/jala/investor_users', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          with: 'user,role',
          investor_id__in: 3,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          ...this.modelPolicy(),
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    },
    modelPolicy() {
      let modelPolicy = {
        _denyShow: true,
        _denyEdit:  false,
        _denyDelete: true,
      }
      let userPolicy = {
        _denyEdit:  !this.$auth.hasJalaTradeRole(['admin']),
        _denyDelete:  !this.$auth.hasJalaTradeRole(['admin']),
        _denyShow:  !this.$auth.hasJalaTradeRole(['admin', 'finance']),
      }
      return {
        ...modelPolicy,
        ...userPolicy,
      }
    },
  },
};
</script>
